import React, { useState, useEffect } from 'react';

function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Don't show if already installed or dismissed
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    if (sessionStorage.getItem('install_dismissed')) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show after 3 seconds
      setTimeout(() => setShow(true), 3000);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // iOS Safari fallback — show custom prompt since it doesn't fire beforeinstallprompt
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isInStandalone = window.navigator.standalone;
    if (isIOS && !isInStandalone && !sessionStorage.getItem('install_dismissed')) {
      setTimeout(() => setShow(true), 3000);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    }
    setShow(false);
  };

  const handleDismiss = () => {
    sessionStorage.setItem('install_dismissed', '1');
    setShow(false);
  };

  if (!show) return null;

  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      width: 'calc(100% - 32px)', maxWidth: 400,
      background: 'linear-gradient(135deg, #1a0033 0%, #2d0057 100%)',
      border: '1px solid rgba(139,95,191,0.4)',
      borderRadius: 20, padding: '16px 20px',
      zIndex: 99999, boxShadow: '0 8px 32px rgba(0,0,0,0.8)',
      display: 'flex', alignItems: 'center', gap: 14,
      animation: 'slideUpPrompt 0.4s ease-out',
      fontFamily: 'DM Sans, sans-serif',
    }}>
      {/* Logo */}
      <img src="/logo192.png" alt="IcingShow" style={{
        width: 52, height: 52, borderRadius: 12, flexShrink: 0,
        border: '2px solid rgba(139,95,191,0.5)',
      }} />

      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ color: '#E6C76A', fontWeight: 800, fontSize: 15, marginBottom: 2 }}>
          Install IcingShow
        </div>
        <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, lineHeight: 1.4 }}>
          {isIOS && !deferredPrompt
            ? "Tap Share then 'Add to Home Screen'"
            : 'Add to your home screen for the best experience'}
        </div>
      </div>

      {/* Buttons */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0 }}>
        {(!isIOS || deferredPrompt) && (
          <button onClick={handleInstall} style={{
            background: 'linear-gradient(135deg,#8B5FBF,#6a3fa0)',
            border: 'none', borderRadius: 10, padding: '7px 16px',
            color: '#fff', fontWeight: 700, fontSize: 13,
            cursor: 'pointer', fontFamily: 'DM Sans, sans-serif',
            whiteSpace: 'nowrap',
          }}>
            Install
          </button>
        )}
        <button onClick={handleDismiss} style={{
          background: 'none', border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: 10, padding: '6px 16px',
          color: 'rgba(255,255,255,0.5)', fontSize: 12,
          cursor: 'pointer', fontFamily: 'DM Sans, sans-serif',
          whiteSpace: 'nowrap',
        }}>
          Not now
        </button>
      </div>

      <style>{`
        @keyframes slideUpPrompt {
          from { transform: translateX(-50%) translateY(100px); opacity: 0; }
          to   { transform: translateX(-50%) translateY(0);    opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export default InstallPrompt;
